/* HG Market — one small motion layer: reveal on enter, gentle parallax, sticky buy bar, marquee pause. */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal: elements with [data-hg-reveal] get .is-in once, staggered by data-hg-delay (ms)
  const revealEls = document.querySelectorAll('[data-hg-reveal]');
  if (reduce) {
    revealEls.forEach((el) => el.classList.add('is-in'));
  } else if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const d = parseInt(e.target.dataset.hgDelay || '0', 10);
          setTimeout(() => e.target.classList.add('is-in'), d);
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  // Parallax: [data-hg-parallax="0.12"] shifts translateY by progress * factor
  const px = Array.from(document.querySelectorAll('[data-hg-parallax]'));
  if (px.length && !reduce) {
    let ticking = false;
    const run = () => {
      const vh = window.innerHeight;
      px.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const f = parseFloat(el.dataset.hgParallax || '0.1');
        const p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
        el.style.transform = `translate3d(0, ${(-p * f * 100).toFixed(2)}px, 0)`;
      });
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(run);
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    run();
  }

  // Sticky buy bar: show after the trigger element leaves the viewport
  const bar = document.querySelector('.hg-stickybar');
  if (bar) {
    const triggerSel = bar.dataset.trigger || '.hg-showcase, .product__info-container';
    const trigger = document.querySelector(triggerSel);
    const footer = document.querySelector('.footer');
    const update = () => {
      let show = false;
      if (trigger) {
        const r = trigger.getBoundingClientRect();
        show = r.bottom < 0;
      } else {
        show = window.scrollY > window.innerHeight * 0.8;
      }
      if (footer) {
        const fr = footer.getBoundingClientRect();
        if (fr.top < window.innerHeight - 40) show = false;
      }
      bar.classList.toggle('is-visible', show);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Marquee: pause on hover/focus handled in CSS; duplicate content for seamless loop
  document.querySelectorAll('.hg-marquee__track').forEach((track) => {
    if (track.dataset.cloned) return;
    track.innerHTML += track.innerHTML;
    track.dataset.cloned = '1';
  });

  // Showcase flip (front/back of bag) — click or keyboard
  document.querySelectorAll('[data-hg-flip]').forEach((btn) => {
    const target = document.querySelector(btn.dataset.hgFlip);
    if (!target) return;
    btn.addEventListener('click', () => {
      const flipped = target.classList.toggle('is-flipped');
      btn.setAttribute('aria-pressed', flipped ? 'true' : 'false');
      const label = btn.querySelector('[data-hg-flip-label]');
      if (label) label.textContent = flipped ? btn.dataset.labelBack : btn.dataset.labelFront;
    });
  });
})();
